export enum AppViews {
    Topview = 'Topview',
    Seatmap = 'Seatmap',
    Pano    = '3d',
    Main    = 'Main',
}